import React, { useState } from "react";
import CountryCode from "../../../config/countryCode.json";
import Input from "../../../components/Input";
import DeleteIcon from "../../../images/delete.svg";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomSelect from "../../../components/CustomSelect";
import AgentConfirmationPopup from "../../../components/AgentConfirmationPopup";

export default function POC({ viewMode, createData, index, setCreateData }) {
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const onDelete = () => {
    //console.log("runnign");
    setCreateData((data) => {
      let newData = { ...data };
      let newContact = newData.contacts.filter((item, i) => i !== index);
      newData.contacts = newContact;
      //console.log(newContact);
      return newData;
    });
  };
  const onChange = (value, item) => {
    setCreateData((data) => {
      let newData = { ...data };
      if (item === "isPrimary") {
        let newDataContact = [];
        data.contacts.map((item, i) => {
          newDataContact[i] = {
            ...item,
            isPrimary: i === index ? true : false,
          };
          return true;
        });
        newData.contacts = newDataContact;
        // return newData
      } else
        newData.contacts[index] = { ...newData.contacts[index], [item]: value };
      return newData;
    });
  };
  return (
    <div className="mt-5 bg-[#f5f5f5] px-4 py-4">
      <div className="flex justify-between items-center mb-5">
        <div className="flex justify-start items-center">
          <p className="text-sm tracking-tight font-semibold mr-2">
            Point of contact {index + 1}
          </p>
          {!viewMode && !createData.contacts[index].isPrimary ? (
            <div
              className="bg-red-200 w-5 h-5 rounded-2xl flex items-center justify-center cursor-pointer"
              onClick={() => setShowDeletePopup(true)}
            >
              <img src={DeleteIcon} className="w-3 h-3" />
            </div>
          ) : null}
        </div>
        <CustomCheckbox
          name={"agent"}
          padding={false}
          viewMode={viewMode}
          text={"Set as Primary"}
          value={createData.contacts[index].isPrimary}
          setValue={(value) => onChange(value, "isPrimary")}
        />
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-4">
        <div className="col-span-1">
          <label>Name</label>
          <Input
            type="text"
            value={createData.contacts[index].name}
            required={true}
            viewMode={viewMode}
            placeholder={"Name"}
            setValue={(value) => onChange(value, "name")}
          />
        </div>
        <div className="col-span-1">
          <label>Designation</label>
          <Input
            type="text"
            value={createData.contacts[index].designation}
            required={true}
            viewMode={viewMode}
            placeholder={"Designation"}
            setValue={(value) => onChange(value, "designation")}
          />
        </div>
        <div className="col-span-2 gap-x-2">
          <div className="grid grid-cols-5 justify-between gap-x-3">
            <div className="col-span-2">
              <label>Country Code</label>
              {viewMode ? (
                <p className="text-xs text-black">
                  {createData.contacts[index].countryCode}
                </p>
              ) : (
                <CustomSelect
                  customLabel={"dial_code"}
                  customValue={"dial_code"}
                  required={true}
                  disabled={viewMode}
                  placeholder={"Select Country Code"}
                  options={CountryCode}
                  value={createData.contacts[index].countryCode}
                  setValue={(value) => onChange(value, "countryCode")}
                />
              )}
            </div>
            <div className="col-span-3">
              <label>Contact Number</label>
              <Input
                type="text"
                value={createData.contacts[index].phoneNumber}
                required={true}
                viewMode={viewMode}
                placeholder={"Contact Number"}
                setValue={(value) => onChange(value, "phoneNumber")}
                maxLength={8}
              />
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <label>Email address</label>
          <Input
            type="email"
            value={createData.contacts[index].email}
            required={true}
            viewMode={viewMode}
            placeholder={"Enter Email"}
            setValue={(value) => onChange(value, "email")}
          />
        </div>
      </div>
      <div className="flex justify-between items-center gap-x-2">
        <CustomCheckbox
          viewMode={viewMode}
          text={"I would like to receive the latest update via SMS"}
          value={createData.contacts[index].smsNotification}
          setValue={(value) => onChange(value, "smsNotification")}
        />
        <CustomCheckbox
          viewMode={viewMode}
          text={"I would like to receive the latest update via email"}
          value={createData.contacts[index].emailNotification}
          setValue={(value) => onChange(value, "emailNotification")}
        />
      </div>
      {showDeletePopup ? (
        <AgentConfirmationPopup
          onClose={setShowDeletePopup}
          onConfirm={onDelete}
          activeData={createData}
          type={"poc"}
          setActiveData={setCreateData}
        />
      ) : null}
    </div>
  );
}
